import { measureCompHeight } from './utils';
export default function create(options, dom) {
  const measures = {
    compHeight: 0
  };
  if (dom) {
    measureCompHeight(measures, dom, true);
  }
  const {
    speed = 0.2
  } = options.namedEffect;
  return [{
    ...options,
    part: 'BG_MEDIA',
    startOffset: {
      name: 'cover',
      offset: {
        type: 'percentage',
        value: 0
      }
    },
    endOffset: {
      name: 'cover',
      offset: {
        type: 'percentage',
        value: 0
      }
    },
    get endOffsetAdd() {
      return `calc(100svh + ${measures.compHeight}px)`;
    },
    keyframes: [{
      transform: `translateY(${100 * speed}svh)`
    }, {
      transform: `translateY(calc((100% - 200lvh) * ${-speed}))`
    }]
  }];
}
//# sourceMappingURL=BgParallax.js.map